// Kwalificeringsvragen (en hun sectiekop) worden door de schakelaar op het
// onderzoek beheerd: alleen op het eerste meetmoment, niet te bewerken,
// verslepen of los te verwijderen. Herkend aan `QualifyingKey`, nooit aan de
// vraagtekst.
//
// Niet verwarren met `isStandardQuestion`: die vragen staan juist op ELK
// meetmoment.
// AI-CONTEXT: See docs/features/sector-kwalificeringsvragen.md

/**
 * @param {object | null | undefined} field - Een QuestionnaireFields-doc
 * @returns {boolean} True als het veld bij een set kwalificeringsvragen hoort.
 */
const isQualifyingQuestion = (field) => (
    typeof field?.QualifyingKey === 'string' && field.QualifyingKey !== ''
)

/**
 * Hoort dit veld bij déze set? De sectiekop draagt de sleutel van de set, elke
 * vraag haar eigen sleutel. Eén definitie voor de schakelaar en de opslag: die
 * gebruikten eerst een voorvoegsel en een sleutellijst naast elkaar.
 *
 * @param {object | null | undefined} field - Een QuestionnaireFields-doc
 * @param {import('./sectorQualifyingQuestions').QualifyingSet} set
 * @returns {boolean}
 */
export const isInQualifyingSet = (field, set) => (
    isQualifyingQuestion(field)
    && (field.QualifyingKey === set.key || set.questions.some((q) => q.key === field.QualifyingKey))
)

export default isQualifyingQuestion
